import { render, staticRenderFns } from "./TruckHistoryListing.vue?vue&type=template&id=363fb50c&scoped=true"
import script from "./TruckHistoryListing.vue?vue&type=script&lang=js"
export * from "./TruckHistoryListing.vue?vue&type=script&lang=js"
import style0 from "./TruckHistoryListing.vue?vue&type=style&index=0&id=363fb50c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363fb50c",
  null
  
)

export default component.exports